import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/stats/base/dists/hypergeometric/cdf';
import __var_2__ from '@stdlib/stats/base/dists/hypergeometric/ctor';
import __var_3__ from '@stdlib/stats/base/dists/hypergeometric/kurtosis';
import __var_4__ from '@stdlib/stats/base/dists/hypergeometric/logpmf';
import __var_5__ from '@stdlib/stats/base/dists/hypergeometric/mean';
import __var_6__ from '@stdlib/stats/base/dists/hypergeometric/mode';
import __var_7__ from '@stdlib/stats/base/dists/hypergeometric/pmf';
import __var_8__ from '@stdlib/stats/base/dists/hypergeometric/quantile';
import __var_9__ from '@stdlib/stats/base/dists/hypergeometric/skewness';
import __var_10__ from '@stdlib/stats/base/dists/hypergeometric/stdev';
import __var_11__ from '@stdlib/stats/base/dists/hypergeometric/variance';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace hypergeometric
*/
var hypergeometric = {};

/**
* @name cdf
* @memberof hypergeometric
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/hypergeometric/cdf}
*/
setReadOnly( hypergeometric, 'cdf', __var_1__);

/**
* @name Hypergeometric
* @memberof hypergeometric
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/hypergeometric/ctor}
*/
setReadOnly( hypergeometric, 'Hypergeometric', __var_2__);

/**
* @name kurtosis
* @memberof hypergeometric
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/hypergeometric/kurtosis}
*/
setReadOnly( hypergeometric, 'kurtosis', __var_3__);

/**
* @name logpmf
* @memberof hypergeometric
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/hypergeometric/logpmf}
*/
setReadOnly( hypergeometric, 'logpmf', __var_4__);

/**
* @name mean
* @memberof hypergeometric
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/hypergeometric/mean}
*/
setReadOnly( hypergeometric, 'mean', __var_5__);

/**
* @name mode
* @memberof hypergeometric
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/hypergeometric/mode}
*/
setReadOnly( hypergeometric, 'mode', __var_6__);

/**
* @name pmf
* @memberof hypergeometric
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/hypergeometric/pmf}
*/
setReadOnly( hypergeometric, 'pmf', __var_7__);

/**
* @name quantile
* @memberof hypergeometric
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/hypergeometric/quantile}
*/
setReadOnly( hypergeometric, 'quantile', __var_8__);

/**
* @name skewness
* @memberof hypergeometric
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/hypergeometric/skewness}
*/
setReadOnly( hypergeometric, 'skewness', __var_9__);

/**
* @name stdev
* @memberof hypergeometric
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/hypergeometric/stdev}
*/
setReadOnly( hypergeometric, 'stdev', __var_10__);

/**
* @name variance
* @memberof hypergeometric
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/hypergeometric/variance}
*/
setReadOnly( hypergeometric, 'variance', __var_11__);


// EXPORTS //
export default hypergeometric;

export { __var_1__ as cdf, __var_2__ as Hypergeometric, __var_3__ as kurtosis, __var_4__ as logpmf, __var_5__ as mean, __var_6__ as mode, __var_7__ as pmf, __var_8__ as quantile, __var_9__ as skewness, __var_10__ as stdev, __var_11__ as variance};